<template>
  <div>
    <new-needs-popup
      :data-to-show="isNewNeedPopupDisplayed"
      @close="changeStateNewNeedPopup(false)"
      @addNeed="
        (newValue) => {
          addNewNeed(newValue);
        }
      "
      :limit="hasLimit ? 22 : null"
    />

    <h3 class="my-15">Besoins au travail</h3>

    <div class="mx-10">
      <div
        v-if="isErrorMaxLengthDisplayed"
        class="text-pink-600 text-base text-center mb-8"
      >
        Le nombre de besoins maximal a été atteint pour ce type de CV
      </div>
      <div
        v-if="isErrorMinLengthDisplayed"
        class="text-pink-600 text-base text-center mb-8"
      >
        Afin d'avoir un rendu visuel optimal, il faut sélectionner entre 3 et 5
        besoins
      </div>
      <div class="relative w-max">
        <add-button
          class="mb-8"
          libelle="Ajouter un nouveau besoin"
          @add="changeStateNewNeedPopup(true)"
        />
      </div>

      <!-- BEGIN list besoins and updated besoins from CV datas -->
      <!-- BEGIN list default besoin add by Neopass -->
      <div class="grid grid-cols-3 gap-3">
        <div
          v-for="(dNeed, kda) in defaultNeeds"
          :key="'default' + kda"
          class="col-span-full md:col-span-1 flex justify-center md:block"
        >
          <tag
            @push="displayDefaultNeed(dNeed)"
            class="cursor-pointer"
            :theme-color="
              (((form.data.needs || {}).value || {}).default || []).includes(
                dNeed
              )
                ? 'indigo-2'
                : 'white'
            "
            :libelle="dNeed"
            text-size="text-sm"
            text-font="font-light"
            :icon="
              (((form.data.needs || {}).value || {}).default || [])[kda] ===
              dNeed
                ? 'minus-circle'
                : 'plus-circle'
            "
            :icon-color="
              (((form.data.needs || {}).value || {}).default || [])[kda] ===
              dNeed
                ? 'text-indigo-600'
                : 'text-gray-600'
            "
            icon-size="w-4 h-4"
            :can-truncate="true"
            :scale-on-hover="true"
            :responsive="false"
          />
        </div>
      </div>
      <!-- END list default besoin add by Neopass -->
      <hr class="my-5" />
      <!-- BEGIN list perso besoins add by Particulier -->
      <div class="grid grid-cols-3 gap-3">
        <div
          v-for="(pNeed, kpa) in persoNeeds"
          :key="'perso' + kpa"
          class="col-span-full lg:col-span-1 flex justify-center md:block"
        >
          <tag
            @push="displayPersoNeed(kpa)"
            class="cursor-pointer"
            :theme-color="pNeed.isDisplayed ? 'indigo-2' : 'white'"
            :libelle="pNeed.value"
            text-size="text-sm"
            text-font="font-light"
            :icon="pNeed.isDisplayed ? 'minus-circle' : 'plus-circle'"
            :icon-color="
              pNeed.isDisplayed ? 'text-indigo-600' : 'text-gray-600'
            "
            icon-size="w-4 h-4"
            :can-truncate="true"
            :scale-on-hover="true"
          />
        </div>
      </div>
      <!-- END list perso besoins add by Particulier -->
      <!-- END list besoins and updated besoins from CV datas -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import draggable from 'vuedraggable';
import ClickOutside from 'vue-click-outside';

import AddButton from './../../../components/Inputs/AddButton.vue';
import Icon from './../../../components/Icon.vue';
import Tag from './../../../components/Tag.vue';
import NewNeedsPopup from './../popup/NewNeedsPopup.vue';
import CVNewValue from './CVNewValue';

import ActionButton from './../../../components/ActionButton.vue';
import Illustration from './../../../components/Illustration.vue';

import Constants from './../../../constants';

export default {
  components: {
    AddButton,
    Icon,
    Tag,
    NewNeedsPopup,
    draggable,
    ActionButton,
    Illustration,
    CVNewValue,
  },

  data() {
    return {
      isNewNeedPopupDisplayed: false,
      metierToDisplay: '',
      isRefresh: false,
      isErrorMaxLengthDisplayed: false,
      isErrorMinLengthDisplayed: false,
      constants: Constants,
    };
  },

  methods: {
    ...mapActions({
      saveDatas: 'curriculumVitae/saveDatas',
    }),

    changeStateNewNeedPopup(state) {
      this.isNewNeedPopupDisplayed = state;
    },

    addNewNeed(listNeed) {
      let list =
        typeof listNeed === 'string'
          ? listNeed.split(',').map((w) => w.trim())
          : listNeed;

      if ((this.form.data.needs || {}).value === undefined) {
        this.form.data.needs = {
          value: {
            default: [],
            perso: [],
          },
        };
      }

      list.forEach((need) => {
        this.form.data.needs.value.perso.push({
          fromNeopass: false,
          isDisplayed:
            this.hasLimit && this.nbDisplayedNeeds >= 5 ? false : true,
          value: need,
        });
      });

      this.$forceUpdate();
      this.saveDatas();

      this.isRefresh = true;
      setTimeout(() => {
        this.isRefresh = false;
      }, 2000);
    },

    displayDefaultNeed(val) {
      if ((this.form.data.needs || {}).value === undefined) {
        this.form.data.needs = {
          value: {
            default: [],
            perso: [],
          },
        };
      }

      if (this.displayLengthErrorMessage(true, null, val)) {
        return;
      }

      if (this.form.data.needs.value.default.includes(val)) {
        // unselect value
        this.form.data.needs.value.default =
          this.form.data.needs.value.default.filter((v) => v != val);
      } else {
        // select value
        this.form.data.needs.value.default.push(val);
      }

      this.$forceUpdate();
      this.saveDatas();
    },

    displayPersoNeed(index) {
      if (
        this.displayLengthErrorMessage(
          false,
          index,
          this.form.data.needs.value.perso[index]
        )
      ) {
        return;
      }

      this.form.data.needs.value.perso[index].isDisplayed =
        !this.form.data.needs.value.perso[index].isDisplayed;

      this.$forceUpdate();
      this.saveDatas();
    },

    displayLengthErrorMessage(isDefault, index = null, val = null) {
      if (this.hasLimit) {
        const needLength = isDefault
          ? Math.ceil(val.length / 28)
          : Math.ceil(val.value.length / 28); //Nombre de ligne du Libelle besoin

        if (
          // There will has too much Besoins
          ((!isDefault &&
            !this.form.data.needs.value.perso[index].isDisplayed) ||
            (isDefault && !this.form.data.needs.value.default.includes(val))) &&
          this.nbDisplayedNeeds + needLength > 5
        ) {
          this.isErrorMaxLengthDisplayed = true;
          return true;
        }
        if (
          // There will has less than max limit
          ((!isDefault &&
            this.form.data.needs.value.perso[index].isDisplayed) ||
            (isDefault && this.form.data.needs.value.default.includes(val))) &&
          this.nbDisplayedNeeds + needLength == 5
        ) {
          this.isErrorMaxLengthDisplayed = false;
          return false;
        }
        if (
          //There will has not enough Besoins
          ((!isDefault &&
            this.form.data.needs.value.perso[index].isDisplayed) ||
            (isDefault && this.form.data.needs.value.default.includes(val))) &&
          this.nbDisplayedNeeds + needLength < 3
        ) {
          this.isErrorMinLengthDisplayed = true;
          return false;
        }
        if (
          // There will has enough Besoins
          ((!isDefault &&
            !this.form.data.needs.value.perso[index].isDisplayed) ||
            (isDefault && !this.form.data.needs.value.default.includes(val))) &&
          this.nbDisplayedNeeds + needLength > 2
        ) {
          this.isErrorMinLengthDisplayed = false;
          return false;
        }
      }

      return false;
    },
  },

  computed: {
    ...mapGetters({
      form: 'curriculumVitae/form',
      backdoor: 'app/backdoor',
    }),

    persoNeeds() {
      this.backdoor; //here value to reactivity
      return (this.form.data.needs.value || {}).perso || [];
    },

    defaultNeeds() {
      return Constants.cvdatas.needs;
    },

    dragOptions() {
      return {
        animation: 500,
      };
    },

    nbDisplayedNeeds() {
      this.backdoor; //for reactivity

      let defaultValues =
        (this.form.data.needs.value || {}).default === undefined
          ? []
          : this.form.data.needs.value.default.filter((a) => a && a != '');
      let persoValues =
        (this.form.data.needs.value || {}).perso === undefined
          ? []
          : this.form.data.needs.value.perso.filter((a) => a.isDisplayed);

      let nbDefaultValues = defaultValues.reduce(
        (acc, need) => acc + Math.ceil(need.length / 28),
        0
      );

      let nbPersoValues = persoValues.reduce(
        (acc, need) => acc + Math.ceil(need.value.length / 28),
        0
      );

      return nbDefaultValues + nbPersoValues;
    },

    hasLimit() {
      return [Constants.CV_TYPES.DASHBOARD].includes(this.form.type);
    },
  },

  watch: {
    form: {
      handler() {
        this.saveDatas();
      },
      deep: true,
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
